// import type { Configuration } from '@repo/api-gw-sdk';
import type { SWRConfiguration } from 'swr';

import type { HttpClient } from './httpClient';

const baseUrl = '/onboarding';

let numOfStatusSamples = 0;

// export const onboarding = (
//   httpClient: HttpClient,
//   config: Configuration,
//   currentProjectId: string
// ) => {
export const onboarding = (httpClient: HttpClient) => {
  return {
    configure: {},
    backupAccount: {
      getDeployStatus: (swrOptions?: SWRConfiguration) => {
        return httpClient.execute(
          [baseUrl, '/backup-account/deploy-status'],
          async () => {
            return numOfStatusSamples++ > 3
              ? {
                  status: 'deployed',
                }
              : {
                  status: 'inProgress',
                };
          },
          swrOptions
        );
      },
    },
    vaultAccount: {},
    sourceAccount: {},
  };
};
